import { graphql } from '../codegen'

export const WhoAmI = graphql(/* GraphQL */ `
  query WhoAmI {
    whoAmI {
      authDisabled
      permissions
      pinStatus
      canViewPrerelease
      parameterEditingAvailable
      preferences {
        language
      }
      user {
        id
        fullName
        email
      }
    }
  }
`)
